import React, { JSX, useEffect, useState } from "react";
import { Dimensions, StyleSheet, View, Text, LayoutChangeEvent, Linking } from "react-native";
import { MD3Theme, useTheme } from "react-native-paper";
import { GestureHandlerRootView, ScrollView } from "react-native-gesture-handler";
import {
  FaqIcon, BedIcon, BookIcon,
  BookingIcon, CheckInIcon,
  CheckOutIcon, HouseIcon, HouseRulesIcon, InfosIcon, InvoiceIcon, FindUsIcon,
  KeyIcon, LocationIcon,
  ParkingIcon, WifiIcon,
  LocalFavoritesIcon,
  ExploreIcon,
  EssentialsIcon,
  GettingAroundIcon,
  UsefullNumberIcon
} from "../../components/Icons";
import i18n from "../../i18n";
import HomePageButton from "../../components/HomePageButton";
import { mobUser } from "../../mobx/MobUser";
import { observer } from "mobx-react";
import { useNavigation } from "@react-navigation/native";
import * as Notifications from "expo-notifications";
//import * as TaskManager from 'expo-task-manager';
import { ApolloQueryResult } from "@apollo/client";
import Queries from "../../api/queries";
import { openMapByLatLng } from "../../utils/itinerary";
import { mobAlert } from "../../mobx/MobAlert";
import { SafeAreaView } from "react-native-safe-area-context";
import FooterDivider from "../../components/FooterDivider";

export type IconType = {
  icon: JSX.Element,
  title: string,
  page?: string,
  onPress?: () => void
};

/* const BACKGROUND_NOTIFICATION_TASK = 'BACKGROUND-NOTIFICATION-TASK';

TaskManager.defineTask(
  BACKGROUND_NOTIFICATION_TASK,
  ({ data, error, executionInfo }) => {
    if (error) {
      console.log('error occurred');
    }
    if (data) {
      console.log('data-----', data);
    }
  })

Notifications.registerTaskAsync(BACKGROUND_NOTIFICATION_TASK); */

const Home = observer(() => {
  const navigation = useNavigation();
  const [latLng, setLatLng] = useState<{ lat: string, lng: string }>();
  const queries = new Queries();
  const theme = useTheme();
  const styles = styleGen(theme);
  const [rowWidths, setRowWidths] = useState<{ [key: number]: number }>({});
  const [scrollPositions, setScrollPositions] = useState<{ [key: number]: number }>({});
  const [contentWidths, setContentWidths] = useState<{ [key: number]: number }>({});

  const InvoiceAction = async () => {
    //const resa = await queries.getResaInfo(mobUser.OiqiaBookingId);
    const receipt = await queries.getReceiptStatus(mobUser.OiqiaBookingId);

    // if (resa?.channelName === "Airbnb") {
    //   mobAlert.setAlert(i18n.t("pages.invoice.unavaliable"), i18n.t("pages.invoice.contactOTA"));
    // } else
    if (receipt?.data?.getReceiptStatus) {
      mobAlert.setAlert(i18n.t("pages.invoice.successTitle"), i18n.t("pages.invoice.successMessage"));
      navigation.navigate("Invoice", { alreadyAsked: true });
    } else {
      navigation.navigate("Invoice", { alreadyAsked: false });
    }
  };


  const FindUsAction = () => {
    Linking.openURL(`https://www.oiqia.com/catalogue`);
  }
  // Fonction pour naviguer vers WelcomeNotes avec le paramètre
  const navigateToWelcomeNotes = (pageType: string) => {
    navigation.navigate('Welcome', { field: pageType });
  };

  useEffect(() => {
    let latLngSubscription;

    async function subscribeToLatLng() {
      try {
        const latLngObservable = await queries.getLatLngById(mobUser.OiqiaBookingId);
        latLngSubscription = latLngObservable.subscribe({
          next(response: ApolloQueryResult<{ NTA_getBookingById: { lat: number, lng: number } }>) {
            setLatLng({
              lat: response?.data?.NTA_getBookingById?.lat?.toString(),
              lng: response?.data?.NTA_getBookingById?.lng?.toString()
            });
          },
          error(err) {
            console.error("Error fetching latLng data:", err);
          }
        });
      } catch (error) {
        console.error("Error setting up subscription:", error);
      }
    }
    const subscription = Notifications.addNotificationResponseReceivedListener(async response => {
      const { screen } = response.notification.request.content.data;
      if (screen) {
        navigation.navigate(screen);
      }
    });

    subscribeToLatLng();

    const checkReservation = async () => {
      try {
        const resa = await queries.getResaInfo(mobUser.OiqiaBookingId);
        if (!resa) mobUser.LogOut();
      } catch (error) {
        console.error("Error checking reservation:", error);
      }
    };

    checkReservation();
    return () => {
      latLngSubscription?.unsubscribe();
      subscription.remove();
    };
  }, []);

  const iconSize = Dimensions.get("screen").height * 0.087;

  const ICONS_LIST: IconType[][] = [
    [
      { icon: <LocationIcon height={iconSize} width={iconSize} />, title: i18n.t("home.itinerary"), onPress: () => openMapByLatLng(latLng.lat, latLng.lng) },
      { icon: <ParkingIcon height={iconSize} width={iconSize} />, title: i18n.t("home.carPark"), page: "Parking" },
      { icon: <KeyIcon height={iconSize} width={iconSize} />, title: i18n.t("home.access"), page: "Access" },
      { icon: <CheckInIcon height={iconSize} width={iconSize} />, title: i18n.t("home.checkIn"), page: "CheckIn" },
    ],
    [
      { icon: <HouseIcon height={iconSize} width={iconSize} />, title: i18n.t("home.housing"), page: "Housing" },
      { icon: <BedIcon height={iconSize} width={iconSize} />, title: i18n.t("home.equipments"), page: "Equipments" },
      { icon: <WifiIcon height={iconSize} width={iconSize} />, title: i18n.t("home.wifi"), page: "Wifi" },
      { icon: <HouseRulesIcon height={iconSize} width={iconSize} />, title: i18n.t("home.houseRules"), page: "Rules" },
      { icon: <InfosIcon height={iconSize} width={iconSize} />, title: i18n.t("home.manuals"), page: "Manuals" },
    ],
    [
      { icon: <BookingIcon height={iconSize} width={iconSize} />, title: i18n.t("home.booking"), page: "BookingInfos" },
      { icon: <FaqIcon height={iconSize} width={iconSize} />, title: i18n.t("home.FAQ"), page: "FAQ" },
      // Icônes modifiées pour naviguer vers WelcomeNotes avec paramètres
      {
        icon: <ExploreIcon height={iconSize} width={iconSize} />,
        title: i18n.t("home.welcomeNotes.exploreTheCity"),
        onPress: () => navigateToWelcomeNotes("discoverCity")
      },
      {
        icon: <LocalFavoritesIcon height={iconSize} width={iconSize} />,
        title: i18n.t("home.welcomeNotes.localFavorites"),
        onPress: () => navigateToWelcomeNotes("localFavorites")
      },
      {
        icon: <EssentialsIcon height={iconSize} width={iconSize} />,
        title: i18n.t("home.welcomeNotes.essentials"),
        onPress: () => navigateToWelcomeNotes("essentialsAround")
      },
      {
        icon: <GettingAroundIcon height={iconSize} width={iconSize} />,
        title: i18n.t("home.welcomeNotes.gettingAround"),
        onPress: () => navigateToWelcomeNotes("gettingAround")
      },
      {
        icon: <UsefullNumberIcon height={iconSize} width={iconSize} />,
        title: i18n.t("home.welcomeNotes.usefullNumbers"),
        onPress: () => navigateToWelcomeNotes("usefulNumbers")
      },
      { icon: <BookIcon height={iconSize} width={iconSize} />, title: i18n.t("home.guestbook"), page: "Guestbook" }
    ],
    [
      { icon: <CheckOutIcon height={iconSize} width={iconSize} />, title: i18n.t("home.checkOut"), page: "CheckOut" },
      { icon: <InvoiceIcon height={iconSize} width={iconSize} />, title: i18n.t("home.invoice"), onPress: InvoiceAction },
      { icon: <FindUsIcon height={iconSize} width={iconSize} />, title: i18n.t("home.findUs"), onPress: FindUsAction }
    ]
  ];

  const SECTIONS = [
    { title: i18n.t("home.arrival"), icons: ICONS_LIST[0] },
    { title: i18n.t("home.housing"), icons: ICONS_LIST[1] },
    { title: i18n.t("home.stay"), icons: ICONS_LIST[2] },
    { title: i18n.t("home.departure"), icons: ICONS_LIST[3] }
  ];

  const handleRowLayout = (index: number) => (event: LayoutChangeEvent) => {
    const { width } = event.nativeEvent.layout;
    setRowWidths(prev => ({ ...prev, [index]: width }));
  };

  const handleScroll = (index: number) => (event: any) => {
    const scrollX = event.nativeEvent.contentOffset.x;
    setScrollPositions(prev => ({ ...prev, [index]: scrollX }));
  };

  const handleContentLayout = (index: number) => (event: LayoutChangeEvent) => {
    const { width } = event.nativeEvent.layout;
    setContentWidths(prev => ({ ...prev, [index]: width }));
  };

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <GestureHandlerRootView >
        <ScrollView
          key={mobUser.Language}
          style={styles.container}
          contentContainerStyle={styles.containerContent}
        // scrollEventThrottle={16}
        // showsVerticalScrollIndicator={true}
        >
          {SECTIONS.map((section, index) => (
            <View key={index} style={styles.section}>
              {section.title && <Text style={styles.sectionTitle}>{section.title}</Text>}
              <View
                style={styles.row}
                onLayout={handleRowLayout(index)}
              >
                <ScrollView
                  horizontal
                  showsHorizontalScrollIndicator={false}
                  onScroll={handleScroll(index)}
                  scrollEventThrottle={16}
                >
                  <View
                    onLayout={handleContentLayout(index)}
                    style={styles.rowContent}
                  >
                    {section.icons.map((component: IconType, idx: number) => (
                      <HomePageButton key={idx} component={component} />
                    ))}
                  </View>
                </ScrollView>

                {(() => {
                  const visibleWidth = rowWidths[index] || 1;
                  const contentWidth = contentWidths[index] || visibleWidth;
                  // Ne pas afficher l'indicateur si tout le contenu est visible
                  if (contentWidth <= visibleWidth) return null;

                  return (
                    <View style={styles.indicatorContainer}>
                      <View
                        style={[
                          styles.indicator,
                          {
                            width: `${(visibleWidth / contentWidth) * 100}%`,
                            transform: [{
                              translateX: (() => {
                                const scrollX = scrollPositions[index] || 0;
                                const scrollableDistance = contentWidth - visibleWidth;
                                const fraction = scrollableDistance > 0 ? scrollX / scrollableDistance : 0;
                                const maxTranslate = visibleWidth - ((visibleWidth / contentWidth) * visibleWidth);
                                return (scrollX / (contentWidth - visibleWidth)) * maxTranslate;
                              })()
                            }]
                          }
                        ]}
                      />
                    </View>
                  );
                })()}
              </View>
            </View>
          ))}
          <FooterDivider />
        </ScrollView>
      </GestureHandlerRootView>
    </SafeAreaView>
  );
});

export default Home;

const styleGen = (theme: MD3Theme) => {
  return StyleSheet.create({
    container: {
      flex: 1,
    },
    containerContent: {
      flexGrow: 1,
      padding: 16,
      backgroundColor: theme.colors.background
    },
    section: {
      marginBottom: 24
    },
    sectionTitle: {
      fontSize: 18,
      fontWeight: "bold",
      marginBottom: 12,
      color: theme.colors.onBackground
    },
    row: {
      backgroundColor: `${theme.colors.onBackground}10`, // 20 pour 20% d'opacité
      borderRadius: 8,
      padding: 8,
      minHeight: 120
    },
    rowContent: {
      flexDirection: "row",
      alignItems: "flex-start",
      paddingHorizontal: 8,
      paddingVertical: 8,
      gap: 30,
    },
    indicatorContainer: {
      height: 2,
      backgroundColor: `${theme.colors.primary}30`,
      marginTop: 8,
      marginHorizontal: 16,
      borderRadius: 1,
      overflow: 'hidden'
    },
    indicator: {
      height: '100%',
      backgroundColor: theme.colors.primary,
      position: 'absolute',
      width: '20%',  // Cette largeur sera calculée dynamiquement
      borderRadius: 1,
    }
  });
};